import React, { useEffect } from 'react'
import type { Theme } from '@material-ui/core'
import { useMediaQuery } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { useUser } from '@paintscout/ui'
import BasePage from 'src/components/layouts/BasePage'
import DocumentTitle from 'src/components/common/DocumentTitle'
import SherwinTrialOverDashboardDesktop from './desktop/SherwinTrialOverDashboardDesktop'
import SherwinTrialOverDashboardMobile from './mobile/SherwinTrialOverDashboardMobile'
import { useTrialDashboardPageStyles } from '../shared/useTrialDashboardPageStyles'

export default function SherwinTrialOverDashboard() {
  const classes = useTrialDashboardPageStyles()
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'))
  const history = useHistory()
  const { isChurned } = useUser()

  // Check if user is churned (cancelled subscription with term ended)
  // If churned, redirect to billing page
  useEffect(() => {
    if (isChurned) {
      history.push('/settings?section=billing-plan')
    }
  }, [isChurned, history])

  // If churned, don't render the trial expiry dashboard (redirect will happen)
  if (isChurned) {
    return null
  }

  return (
    <BasePage className={classes.basePage} width="xl">
      <DocumentTitle title="Trial Expired" />
      {isMobile ? <SherwinTrialOverDashboardMobile /> : <SherwinTrialOverDashboardDesktop />}
    </BasePage>
  )
}
